import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { ColorsEnum, Text } from './text';

export const Footer = () => {
  return (
    <div
      className={clsx(
        'flex w-full font-light px-7 py-12 mt-auto',
        PaletteUtils.isVcfcPalette && 'bg-primary dark:bg-slate',
        PaletteUtils.isInsigniaPalette && 'bg-very-pale-green dark:bg-gray-brown',
      )}
    >
      <div className='max-w-[762px] mx-auto flex flex-col gap-6 text-center'>
        <Text color={PaletteUtils.getColor(undefined, ColorsEnum.White)}>
          {PaletteUtils.isInsigniaPalette && 'Insignia Cards Limited '}
          {PaletteUtils.isVcfcPalette && 'Valletta Credit Finance Corporation Ltd. '}
          is licensed by the MFSA in terms of the Financial lnstitutions Act 1994 <br />
          and registered in Malta - C-54426.Palazzo Spinola, 46, St Christopher Street, Valletta VLT1464.
        </Text>
        <Text color={PaletteUtils.getColor(undefined, ColorsEnum.White)}>For any assistance please contact the number on the back of your card.</Text>
      </div>
    </div>
  );
};
